import { render, staticRenderFns } from "./LayeredParallax.vue?vue&type=template&id=10d39840&scoped=true&"
import script from "./LayeredParallax.vue?vue&type=script&lang=js&"
export * from "./LayeredParallax.vue?vue&type=script&lang=js&"
import style0 from "./LayeredParallax.vue?vue&type=style&index=0&id=10d39840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d39840",
  null
  
)

export default component.exports